"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('./classes'),
    Order = _require.Order;

var PRODUCTS = require('../products/constants');

function isSample(_ref) {
  var product_type = _ref.product_type;
  return [PRODUCTS.SILK_RIBBON_SAMPLES, PRODUCTS.CLASSIC_WEDDING_INVITATION_SAMPLES, PRODUCTS.LETTERPRESS_WEDDING_INVITATION_SAMPLES].includes(product_type);
}

function canGoWithSamples(_ref2) {
  var product_type = _ref2.product_type;
  return [PRODUCTS.VELLUM_JACKETS, PRODUCTS.WAX_SEALS, PRODUCTS.SILK_RIBBON].includes(product_type);
}

function isTableNumbersOrSigns(_ref3) {
  var product_type = _ref3.product_type;
  return [PRODUCTS.TABLE_NUMBERS, PRODUCTS.TABLE_NUMBER_REPRINTS, PRODUCTS.RESERVED_SIGNS, PRODUCTS.RESERVED_SIGN_REPRINTS, PRODUCTS.WEDDING_SIGNS, PRODUCTS.WEDDING_SIGN_REPRINTS].includes(product_type);
}

function isCustomizable(product) {
  return !isTableNumbersOrSigns(product) && !isSample(product);
}

function splitOrderByContents(order) {
  var products = order.products;
  var order_params = JSON.parse(JSON.stringify(order));
  delete order_params.products;
  var sampleProducts = products.filter(isSample);
  var nonCustomizableStationery = products.filter(isTableNumbersOrSigns);
  var customizableStationery = products.filter(isCustomizable);
  var customizableStationeryGoesWithSamples = customizableStationery.every(canGoWithSamples);
  var sampleOrder;
  var nonCustomizableOrder;
  var customizableOrder;

  if (sampleProducts.length) {
    if (customizableStationeryGoesWithSamples) {
      sampleOrder = new Order(_objectSpread(_objectSpread({}, order_params), {}, {
        products: [].concat(_toConsumableArray(customizableStationery), _toConsumableArray(sampleProducts))
      }));
    } else {
      sampleOrder = new Order(_objectSpread(_objectSpread({}, order_params), {}, {
        products: sampleProducts
      }));
    }

    sampleOrder.designation = 'sample_orders';
    sampleOrder.id = '';

    if (order.payment_status === 'paid') {
      sampleOrder.client_payment = sampleOrder.total_price;
    }
  }

  if (customizableStationery.length && !customizableStationeryGoesWithSamples) {
    // if there's customizable stationery, we send any non-customizable stationery with that.
    customizableOrder = new Order(_objectSpread(_objectSpread({}, order_params), {}, {
      products: [].concat(_toConsumableArray(customizableStationery), _toConsumableArray(nonCustomizableStationery))
    }));
    customizableOrder.designation = 'orders';
    customizableOrder.id = '';

    if (order.payment_status === 'paid') {
      customizableOrder.client_payment = customizableOrder.total_price;
    }
  } else if (nonCustomizableStationery.length) {
    // if there is no customizable stationery, we create a new nonCustomizableStationery order
    // UNLESS the non-customizable stationery goes with the sample order.
    nonCustomizableOrder = new Order(_objectSpread(_objectSpread({}, order_params), {}, {
      products: nonCustomizableStationery
    }));
    nonCustomizableOrder.designation = 'table_numbers';
    nonCustomizableOrder.id = '';

    if (order.payment_status === 'paid') {
      nonCustomizableOrder.client_payment = nonCustomizableOrder.total_price;
    }
  }

  return [customizableOrder, nonCustomizableOrder, sampleOrder];
}

module.exports = splitOrderByContents;